import PropTypes from "prop-types";
// form
import { Controller, useFormContext } from "react-hook-form";
// @mui
import { TextField } from "@mui/material";

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  max_value: PropTypes.string,
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  multiline: PropTypes.bool,
};

export default function RHFTextField({
  disabled = false,
  name,
  max_value,
  helperText,
  label,
  multiline,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          multiline={multiline}
          label={label}
          disabled={disabled}
          {...field}
          fullWidth
          value={
            typeof field.value === "number" && field.value === 0
              ? ""
              : field.value
          }
          error={!!error}
          InputProps={{
            inputProps: {
              max: max_value,
            },
            autoComplete: "new-password",
          }}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}
